import { Link } from "react-router-dom";
import type { Comic } from "@/mocks/comics";

export default function ComicCard({ comic }: { comic: Comic }) {
  return (
    <Link
      to={`/comics/${comic.id}`}
      className="group block overflow-hidden rounded-lg border border-background-200/70 bg-background-100 transition-colors hover:border-primary-300"
    >
      <div className="relative aspect-[2/3] w-full overflow-hidden">
        <img
          src={comic.cover}
          alt={`${comic.title}漫画封面`}
          title={`${comic.title} · 扑飞漫画网`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute left-2 top-2 rounded-full bg-background-950/70 px-2.5 py-0.5 text-xs text-background-50 backdrop-blur">
          {comic.status}
        </span>
        <span className="absolute right-2 top-2 rounded-full bg-primary-500 px-2 py-0.5 text-xs font-semibold text-background-50">
          {comic.rating}
        </span>
      </div>
      <div className="p-3">
        <h4 className="truncate font-heading text-base text-foreground-950">{comic.title}</h4>
        <div className="mt-2 flex items-center justify-between text-xs text-foreground-600">
          <span>{comic.genre}</span>
          <span>{comic.chapters}话</span>
        </div>
        <div className="mt-2 flex flex-wrap gap-1.5">
          {comic.tags.slice(0, 2).map((t) => (
            <span key={t} className="rounded-full bg-secondary-100 px-2 py-0.5 text-xs text-secondary-900">
              {t}
            </span>
          ))}
        </div>
      </div>
    </Link>
  );
}